import { Utils } from "../../utils";
import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";

export class Note {
    Id: string
    NoteText: string
    User: string
    CreationDate: string

    constructor(id: string, text: string, user: string, date: string) {
        this.Id = id;
        this.NoteText = text;
        this.User = user;
        this.CreationDate = date;
    }
}

class NotesViewModel {
    notes = ko.observableArray<Note>([]);

    deleteNote = async (id: string) => {
        await RNSAPI.deleteNote(id);
        this.loadNotes();
    }

    editNote = async (id: string) => {
        await MainViewModel.RoutingTable.showNoteView({ id: id });
        this.loadNotes();
    }

    async loadNotes() {
        let notes = await RNSAPI.getNotes();
        this.notes(notes.Payload.Notes);
    }

    constructor(params) {
        this.loadNotes();
    }
}

let html = fs.readFileSync(__dirname + '/notes.html', 'utf8');

ko.components.register("notes-view", {
    viewModel: NotesViewModel,
    template: html
});